import client from '../httpClient';

const getProhibitWordsApi = (params) => {
  return client.get('/prohibited-words', { params });
};

export default getProhibitWordsApi;
